import React, { useContext, useEffect, useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import { FormControlLabel, Step, StepLabel, Stepper } from "@mui/material";
import { LicenseTypes, Operation } from "../../../../../../utils/Enum.types";
import { Button } from "../../../../../../stories/Button/Button";
import { Label } from "../../../../../../stories/Label/Label";
import { Keys } from "../../../../../../utils/Enum.keys";
import {
  addCountryCode,
  handleFormEvent,
  handleMUISelectEvent,
  hanldeTextAreaFormEvent,
  removeMoreSpace,
} from "../../../../../../utils/UtilFunctions";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import { LabelProps } from "../../../../../../utils/types";
import InputNumber from "../../../../../common/Input/InputNumber";
import {
  PredefinedDataTypes,
  SupplierFormDetails,
} from "../../../../../../utils/formTypes";
import { Form, Formik, FormikProps } from "formik";
import { supplierDetailsValidation } from "../../../../../../utils/validationSchema";
import { AntSwitch } from "../../../../../../styles/Switch";
import PredefinedAutocomplete from "../../../../../../customComponents/PredefinedAutocmplete";
import InputHoc from "../../../../../common/Input/Index";
import { AddSupplier, UpdateSupplier } from "../queries/mutations";
import {
  AddSupplierResult,
  AddSupplierVar,
  AtsAcLdgr,
  AtsAcLdgrOrderField,
  LdgrQueryType,
  UpdateSupplierResult,
  UpdateSupplierVar,
} from "../queries/types";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../../../utils/constants";

import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import { GetSupplierByNodeId, GetSuppliers } from "../queries/queries";
import {
  nodeVar,
  OrderDirection,
} from "../../../../../../utils/commonQueryTypes";
import { AppContext } from "../../../../../../context/context";
import MessageModal from "../../../../../../customComponents/MessageModal";
import { payloadTypes } from "../../../../../../context/reducer";
import LoadingModal from "../../../../../pages/LoadingModal";
import Navbar from "../../../../../common/layout/Navbar";
import PredefinedSelect from "../../../../../../customComponents/PredefinedSelect";
import useLabels from "../../../../../../customHooks/useLabels";
import useFormJson from "../../../../../../json/useFormJson";
export interface supplierProps {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  operation: Operation;
  step: number;
}

const BasicDetails = ({ operation, step, setModalFlag }: supplierProps) => {
  const { ledgerLabel } = useLabels();
  const { supplierDetails } = useFormJson();
  const SupplierStepHeader = (showMulLocation: boolean) => {
    if (showMulLocation)
      return [
        `${ledgerLabel} Basic Details`,
        `${ledgerLabel} Required Details`,
        "Multiple Location",
      ];
    else
      return [
        `${ledgerLabel} Basic Details`,
        `${ledgerLabel} Required Details`,
      ];
  };
  const navigate = useNavigate();
  const { customer_id, supplier_id, company_id } = useUrlParams();
  const [message, setMessage] = useState(emptyMessage);

  const { user_details } = useLoggedInUserDetails();

  const { state, dispatch } = useContext(AppContext);

  const initialValues: SupplierFormDetails = {
    supplier_name: "",
    address: "",
    city: "",
    state: "",
    pin: "",
    country: "",
    phone: "",
    email: "",
    multi_location: false,
    includeDeviceType: false,
    contactPerson: "",
    contactPersonAddress: "",
    contactPersonState: "",
    contactPersonCity: "",
    contactPersonPin: "",
    contactPersonCountry: "",
    contactPersonMobile: "",
    contactPersonEmail: "",
    contactPersonAadhar: "",
  };

  const [formData, setFormData] = useState<SupplierFormDetails>(initialValues);
  const [GetSupplier, { data: supplierData }] = useLazyQuery<
    { node: AtsAcLdgr },
    nodeVar
  >(GetSupplierByNodeId);
  const [AddSupplierDetails, { loading: AddSupplierLoading }] = useMutation<
    AddSupplierResult,
    AddSupplierVar
  >(AddSupplier, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [UpdateSupplierDetails, { loading: UpdateSupplierLoading }] =
    useMutation<UpdateSupplierResult, UpdateSupplierVar>(UpdateSupplier, {
      onError: (e) => {
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        });
      },
    });

  const stepsHeader = SupplierStepHeader(formData.multi_location);
  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<SupplierFormDetails>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
    meta.handleChange(e);
  };

  const handleSubmit = async () => {
    if (customer_id) {
      if (
        operation === Operation.CREATE &&
        supplier_id === 0 &&
        supplierData === undefined
      ) {
        const empAdded = AddSupplierDetails({
          variables: {
            user_details,
            customer_id,
            supplier_name: removeMoreSpace(formData.supplier_name),
            multi_location: formData.multi_location,
            includeDeviceType: formData.includeDeviceType
              ? formData.includeDeviceType
              : false,
            input: {
              address: removeMoreSpace(formData.address),
              alterContactPersonMobile: "",
              alterContactPersonEmail: "",
              alterContactPersonAadhar: "",
              alterContactPerson: "",
              bankAcNo: "",
              bankBranch: "",
              bankIfsc: "",
              bankMicr: "",
              bankName: "",
              city: formData.city,
              contactPerson: removeMoreSpace(formData.contactPerson),
              contactPersonAadhar: formData.contactPersonAadhar,
              contactPersonAddress: removeMoreSpace(
                formData.contactPersonAddress
              ),
              contactPersonCity: formData.contactPersonCity,
              contactPersonCountry: formData.contactPersonCountry,
              contactPersonEmail: formData.contactPersonEmail,
              contactPersonMobile: addCountryCode(formData.contactPersonMobile),
              contactPersonPin: formData.contactPersonPin,
              contactPersonState: formData.contactPersonState,
              country: formData.country,
              email: formData.email,
              gstNo: "",
              panNo: "",
              phone: addCountryCode(formData.phone),
              pin: formData.pin,
              proficiency: "",
              state: formData.state,
              tanNo: "",
              vatNo: "",
            },
          },
          refetchQueries: [
            {
              query: GetSuppliers,
              variables: {
                after: null,
                customer_id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsAcLdgrOrderField.CREATED_AT,
                },

                name: EMPTY_STRING,
                input: {
                  query_type: LdgrQueryType.ALL,
                  itemID: 0,
                },
              },
            },
          ],
        });
        const { data } = await empAdded;
        if (data && data.AddSupplier && data.AddSupplier.id) {
          dispatch({
            type: payloadTypes.SET_SUPPLIER_ID,
            payload: {
              supplierId: data.AddSupplier.id,
            },
          });
          setMessage({
            flag: true,
            message: `${ledgerLabel} added successfully`,
            operation: Operation.CREATE,
          });
        }
      } else {
        const customerUpdated = UpdateSupplierDetails({
          variables: {
            user_details,
            customer_id,
            supplier_id: state.supplierId,
            includeDeviceType: formData.includeDeviceType
              ? formData.includeDeviceType
              : false,
            input: {
              address: removeMoreSpace(formData.address),
              alterContactPersonMobile: "",
              alterContactPersonEmail: "",
              alterContactPersonAadhar: "",
              alterContactPerson: "",
              bankAcNo: "",
              bankBranch: "",
              bankIfsc: "",
              bankMicr: "",
              bankName: "",
              city: formData.city,
              contactPerson: removeMoreSpace(formData.contactPerson),
              contactPersonAadhar: formData.contactPersonAadhar,
              contactPersonAddress: removeMoreSpace(
                formData.contactPersonAddress
              ),
              contactPersonCity: formData.contactPersonCity,
              contactPersonCountry: formData.contactPersonCountry,
              contactPersonEmail: formData.contactPersonEmail,
              contactPersonMobile: addCountryCode(formData.contactPersonMobile),
              contactPersonPin: formData.contactPersonPin,
              contactPersonState: formData.contactPersonState,
              country: formData.country,
              email: formData.email,
              gstNo: "",
              panNo: "",
              phone: addCountryCode(formData.phone),
              pin: formData.pin,
              proficiency: "",
              state: formData.state,
              supplieName: formData.supplier_name,
              tanNo: "",
              vatNo: "",
            },
          },
          refetchQueries: [
            {
              query: GetSuppliers,
              variables: {
                after: null,
                customer_id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsAcLdgrOrderField.CREATED_AT,
                },

                name: EMPTY_STRING,
                input: {
                  query_type: LdgrQueryType.ALL,
                  itemID: 0,
                },
              },
            },
          ],
        });
        const { data } = await customerUpdated;

        if (data && data.UpdateSupplier) {
          setMessage({
            flag: true,
            message: `${ledgerLabel} details updated successfully`,
            operation: Operation.CREATE,
          });
        }
      }
    }
  };

  const handleNumberChange = (name: string, value: string) => {
    setFormData((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleClear = () => {
    const inputElement = document.getElementsByName(
      "supplier_name"
    )[0] as HTMLInputElement;
    if (inputElement) inputElement.focus();
    setFormData(initialValues);
  };
  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      handleClear();
      if (operation === Operation.CREATE) {
        navigate(
          `/${customer_id}/company/masters/supplier/${state.supplierId}/requireddetails`
        );
      } else {
        setModalFlag(false);
      }
    }
    setMessage(emptyMessage);
  };

  useEffect(() => {
    if (state.supplierId || supplier_id) {
      GetSupplier({
        variables: {
          id: supplier_id ? supplier_id : state.supplierId,
        },
      }).then(({ data }) => {
        if (data && data.node)
          setFormData({
            supplier_name: data.node.desc,
            address: data.node.supplier_details.address,
            city: data.node.supplier_details.city,
            state: data.node.supplier_details.state,
            pin: data.node.supplier_details.pin,
            country: data.node.supplier_details.country,
            phone: data.node.supplier_details.phone,
            email: data.node.supplier_details.email,
            includeDeviceType: data.node.includeDeviceType,
            multi_location: data.node.multiLocation,

            contactPerson: data.node.supplier_details.contactPerson,
            contactPersonAddress:
              data.node.supplier_details.contactPersonAddress,
            contactPersonState: data.node.supplier_details.contactPersonState,
            contactPersonCity: data.node.supplier_details.contactPersonCity,
            contactPersonPin: data.node.supplier_details.contactPersonPin,
            contactPersonCountry:
              data.node.supplier_details.contactPersonCountry,
            contactPersonMobile: data.node.supplier_details.contactPersonMobile,
            contactPersonEmail: data.node.supplier_details.contactPersonEmail,
            contactPersonAadhar: data.node.supplier_details.contactPersonAadhar,
          });
      });
    }
  }, [GetSupplier, state.supplierId, supplier_id]);

  return (
    <>
      {operation === Operation.CREATE && (
        <>
          <Navbar NavType={LicenseTypes.CUSTOMER_USERS} />{" "}
          <Title>Add {ledgerLabel} Details</Title>
        </>
      )}
      <Formik
        initialValues={formData}
        validationSchema={supplierDetailsValidation}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
      >
        {(meta) => {
          return (
            <Form
              className={`supplier__add${
                operation === Operation.CREATE ? "" : "--modal"
              }`}
            >
              {operation === Operation.UPDATE && (
                <div className="supplier__add--title">
                  <Title>Edit Basic Details</Title>

                  <img src={Close} alt="" onClick={() => setModalFlag(false)} />
                </div>
              )}

              {operation === Operation.CREATE ? (
                <Stepper alternativeLabel activeStep={step - 1}>
                  {stepsHeader.map((step, index) => {
                    return (
                      <Step key={index}>
                        <StepLabel>{step}</StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              ) : null}

              <div
                className={`supplier__add--form${
                  operation === Operation.CREATE ? "" : "--edit"
                }`}
              >
                <div className="supplier__add--form-details">
                  <div className="supplier__add--form-details--left">
                    <div className="supplier__add--details">
                      <h4>{ledgerLabel} Details</h4>
                    </div>

                    {supplierDetails.details.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.dataType === "number") {
                          return (
                            <div className="label-grid" key={key}>
                              <Label>{field.labelName}</Label>
                              <InputNumber
                                value={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => handleValueChange(e, meta)}
                                required={field.required}
                                maxLength={field.maxLength}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </div>
                          );
                        } else if (field.dataType === "textarea") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLTextAreaElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  type={field.dataType}
                                  rows={3}
                                  name={field.inputName}
                                  onKeyDown={(e) => {
                                    hanldeTextAreaFormEvent(
                                      e,
                                      setFormData as (
                                        value: React.SetStateAction<{
                                          [key: string]: string | number;
                                        }>
                                      ) => void
                                    );
                                  }}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "city") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    city: e,
                                  });
                                }}
                                type={PredefinedDataTypes.CITY}
                                value={formData.city as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "state") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e, state_code) => {
                                  setFormData({
                                    ...formData,
                                    state: e,
                                    gstStateCode: state_code
                                      ? state_code
                                      : EMPTY_STRING,
                                  });
                                }}
                                type={PredefinedDataTypes.STATE}
                                value={formData.state as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "country") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    country: e,
                                  });
                                }}
                                type={PredefinedDataTypes.COUNTRY}
                                value={formData.country as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "mobile") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PhoneInput
                                country={"in"}
                                value={formData[field.inputName] as string}
                                onChange={(e: string) => {
                                  handleNumberChange(field.inputName, e);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === Keys.ENTER) {
                                    e.preventDefault();
                                    handleMUISelectEvent(e);
                                  }
                                }}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              ) : null}
                            </div>
                          );
                        } else {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                required={field.required}
                                autoFocus={field.autoFocus}
                                type={field.dataType}
                                onBlur={meta.handleBlur}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                    <div className="supplier__add--details">
                      <h4>Multiple Location Available</h4>
                    </div>
                    <div
                      className={`supplier__add--details--block${
                        formData.multi_location ? "--wb" : ""
                      }`}
                    >
                      <FormControlLabel
                        label="Include Device Type"
                        labelPlacement="start"
                        control={
                          <AntSwitch
                            checked={formData.includeDeviceType}
                            onChange={(e) => {
                              const { checked } = e.target;
                              setFormData({
                                ...formData,
                                includeDeviceType: checked,
                              });
                            }}
                            onKeyDown={handleFormEvent}
                          />
                        }
                        className="supplier__add--details--form-labels"
                      />
                      <FormControlLabel
                        label="Multiple Location Available"
                        labelPlacement="start"
                        control={
                          <AntSwitch
                            checked={formData.multi_location}
                            onChange={(e) => {
                              const { checked } = e.target;
                              setFormData({
                                ...formData,
                                multi_location: checked,
                              });
                            }}
                            onKeyDown={handleFormEvent}
                          />
                        }
                        className="supplier__add--details--form-labels"
                      />
                    </div>
                  </div>
                  <div className="supplier__add--form-details--right">
                    <div className="supplier__add--details">
                      <h4>Contact Person Details</h4>
                    </div>
                    {supplierDetails.contactFields.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.dataType === "number") {
                          return (
                            <React.Fragment>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  value={formData[field.inputName]}
                                  name={field.inputName}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => handleValueChange(e, meta)}
                                  required={field.required}
                                  onBlur={meta.handleBlur}
                                  onKeyDown={handleFormEvent}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "mobile") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PhoneInput
                                country={"in"}
                                value={formData[field.inputName] as string}
                                onChange={(e: string) => {
                                  handleNumberChange(field.inputName, e);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === Keys.ENTER) {
                                    e.preventDefault();
                                    handleMUISelectEvent(e);
                                  }
                                }}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              ) : null}
                            </div>
                          );
                        } else if (field.dataType === "boolean") {
                          return (
                            <FormControlLabel
                              label={field.labelName}
                              labelPlacement="start"
                              name={field.inputName}
                              control={
                                <AntSwitch
                                  onBlur={meta.handleBlur}
                                  checked={formData[field.inputName] as boolean}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      [field.inputName]: e.target.checked,
                                    });
                                  }}
                                />
                              }
                              className="supplier__add--details--form-labels"
                            />
                          );
                        }
                        if (field.dataType === "textarea") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLTextAreaElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  type={field.dataType}
                                  rows={3}
                                  // onKeyDown={hanldeTextAreaFormEvent}
                                  name={field.inputName}
                                  onBlur={meta.handleBlur}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "city") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    contactPersonCity: e,
                                  });
                                }}
                                type={PredefinedDataTypes.CITY}
                                value={formData.contactPersonCity as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "state") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e, state_code) => {
                                  setFormData({
                                    ...formData,
                                    contactPersonState: e,
                                    gstStateCode: state_code
                                      ? state_code
                                      : EMPTY_STRING,
                                  });
                                }}
                                type={PredefinedDataTypes.STATE}
                                value={formData.contactPersonState as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "country") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    contactPersonCountry: e,
                                  });
                                }}
                                type={PredefinedDataTypes.COUNTRY}
                                value={formData.contactPersonCountry as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                required={field.required}
                                autoFocus={field.autoFocus}
                                type={field.dataType}
                                onBlur={meta.handleBlur}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                  </div>
                </div>
                {operation === Operation.CREATE ? (
                  <>
                    <Button mode="save-continue" type="submit" />
                    <Button mode="clear" type="button" onClick={handleClear} />
                    <Button
                      mode="back"
                      type="button"
                      onClick={() => {
                        dispatch({
                          type: payloadTypes.SET_SUPPLIER_ID,
                          payload: {
                            supplierId: 0,
                          },
                        });
                        navigate(`/${customer_id}/company/masters/supplier`);
                      }}
                    />
                  </>
                ) : (
                  <>
                    <Button mode="save" />
                    <Button mode="clear" onClick={handleClear} />
                    <Button mode="cancel" onClick={() => setModalFlag(false)} />
                  </>
                )}
              </div>
              <MessageModal
                handleClose={handleClose}
                modalFlag={message.flag}
                operation={message.operation}
                value={message.message}
              />
            </Form>
          );
        }}
      </Formik>
      <LoadingModal flag={AddSupplierLoading || UpdateSupplierLoading} />
    </>
  );
};

export default BasicDetails;
